import { TableHeadCell as FBTableHeadCell } from "flowbite-react";
import SortArrow from "../SortArrow";

const TableHeadCell = ({onChangeOrder, sortable, ...props}) => {
  const tmpProps = { ...props };
  const headCellClasses =
    "bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base text-tenken-gray-900";
  tmpProps.className = props?.className
    ? props.className + " " + headCellClasses
    : headCellClasses;
  const childClass = props?.childclass ? props.childclass : "";
  const children = sortable ? (
    <div className={`flex items-center whitespace-nowrap ${childClass}`}>
      <div className="cursor-pointer" onClick={onChangeOrder}>{tmpProps.children}</div>
      <SortArrow
        order={tmpProps.order}
        onChangeOrder={onChangeOrder}
      />
    </div>
  ) : (
    tmpProps.children
  );
  return (
    <FBTableHeadCell {...tmpProps}>{children}</FBTableHeadCell>
  );
}

export default TableHeadCell;